import { IRadioBlockItemData } from 'common/components/RadioBlock/RadioBlock';

export const getRoleNameFromId = (id: number) => rolesData.find((r) => r.id === id)?.value;
export const getRoleIdFromName = (name: string) => rolesData.find((r) => r.value === name)?.id;

export const rolesData: IRadioBlockItemData[] = [
  {
    id: 1,
    icon: 'UserAuthenticated',
    value: 'Authenticated',
    titleKey: 'roles.Authenticated',
    subTitleKey: 'roles.AuthenticatedSubtitle',
    containerSelStyle: 'bg-blue-400 border-blue-400 shadow-lg blue-400',
    iconStyle: 'text-white',
    iconContainerStyle: 'bg-blue-400',
    iconSelStyle: 'text-blue-400',
    iconContainerSelStyle: 'bg-white',
  },
  {
    id: 5,
    icon: 'Mediator',
    value: 'Mediator',
    titleKey: 'roles.Mediator',
    subTitleKey: 'roles.MediatorSubtitle',
    containerSelStyle: 'bg-purple-500 border-purple-500 shadow-lg purple-500',
    iconStyle: 'text-white',
    iconContainerStyle: 'bg-purple-500',
    iconSelStyle: 'text-purple-500',
    iconContainerSelStyle: 'bg-white',
  },
  {
    id: 4,
    icon: 'UserAdmin',
    value: 'Administrateur',
    titleKey: 'roles.Administrateur',
    subTitleKey: 'roles.AdministrateurSubtitle',
    containerSelStyle: 'bg-orange-500 border-orange-500 shadow-lg orange-500',
    iconStyle: 'text-white',
    iconContainerStyle: 'bg-orange-500',
    iconSelStyle: 'text-orange-500',
    iconContainerSelStyle: 'bg-white',
  },
  {
    id: 3,
    icon: 'UserSuperAdmin',
    value: 'SuperAdmin',
    titleKey: 'roles.SuperAdmin',
    subTitleKey: 'roles.SuperAdminSubtitle',
    containerSelStyle: 'bg-slate-400 border-slate-400 shadow-lg slate-400',
    iconStyle: 'text-white',
    iconContainerStyle: 'bg-slate-400',
    iconSelStyle: 'text-slate-400',
    iconContainerSelStyle: 'bg-white',
  },
];
